import { Link } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";

const CONTENT = {
  privacy: {
    title: "Privacy",
    body: [
      "This privacy notice is a placeholder prepared for professional legal review and does not yet constitute approved counsel language.",
      "DBRF collects the information you provide through the challenge brief and network application forms in order to assess fit and, where relevant, to contact you. Submissions are stored securely and are accessible only to authorised roles.",
      "Before public launch, DBRF will confirm the lawful basis for processing, retention periods, data-subject rights, the identity of the data controller and any processors, and the process for requests and complaints.",
    ],
  },
  terms: {
    title: "Terms",
    body: [
      "These terms are a placeholder prepared for professional legal review and do not yet constitute approved counsel language.",
      "Content on this site is provided for general information. Scientific and technical information does not constitute a representation of validated performance unless expressly identified. Catalogue entries do not imply validation.",
      "Scope, governance and commercial structure are agreed for each engagement. Nothing on this site is an offer or a promise of employment, project allocation or a specific result.",
    ],
  },
  accessibility: {
    title: "Accessibility",
    body: [
      "DBRF aims to meet WCAG 2.2 AA. This statement is a placeholder for professional review.",
      "The site is built for full keyboard navigation, visible focus states, sufficient colour contrast, correct landmarks and heading order, and a reduced-motion mode. A skip-to-content link is provided.",
      "If you encounter an accessibility barrier, a verified contact route will be published here for reporting issues.",
    ],
  },
  cookies: {
    title: "Cookie Preferences",
    body: [
      "This cookie notice is a placeholder for professional legal review.",
      "The site uses only the cookies strictly necessary for secure authentication of the protected admin area. No invasive advertising or cross-site tracking is used by default.",
      "Where consent-aware analytics are added later, a preference control will be presented here and no non-essential cookies will be set before consent.",
    ],
  },
};

export default function Legal({ variant }) {
  const c = CONTENT[variant];
  return (
    <>
      <PageMeta title={c.title} description={`${c.title} — placeholder pending professional legal review.`} />
      <section className="container-dbrf py-16 lg:py-24">
        <p className="eyebrow mb-4">Legal · placeholder</p>
        <h1 className="font-display font-extrabold text-navy" style={{ fontSize: "clamp(2rem,4vw,3rem)" }}>{c.title}</h1>
        <div className="mt-4 inline-block rounded-full border border-[var(--warning)]/40 bg-[var(--warning)]/10 px-3 py-1">
          <span className="font-mono text-xs text-[var(--warning)]">Clearly marked placeholder — pending professional legal review.</span>
        </div>
        <div className="reading mt-8 space-y-5">
          {c.body.map((p, i) => <p key={i} className="text-[var(--mineral)]" style={{ lineHeight: 1.7 }}>{p}</p>)}
        </div>
        <Link to="/" className="mt-10 inline-block text-sm font-semibold text-[var(--cobalt)] link-underline">Return home</Link>
      </section>
    </>
  );
}
